import { initialState, EditStoreState } from './selectors';
import * as actions from './actions';

export default (state: EditStoreState = initialState, action: any) => {
  switch (action.type) {
    case actions.LOAD_STORE_ACTIONS.REQUESTED: {
      return { ...state, loading: true };
    }

    case actions.LOAD_STORE_ACTIONS.SUCCEEDED: {
      return { ...state, store: action.payload.store, loading: false };
    }

    case actions.EDIT_STORE_ACTIONS.SUCCEEDED: {
      return { ...state, store: action.payload?.store };
    }

    default: {
      return state;
    }
  }
};



// WEBPACK FOOTER //
// ./src/scenes/EditStore/services/reducer.ts